// Самовывоз от продавца на оформлении заказа (веб-витрина, 17.10.2026).
import type { DeliveryOption, DeliveryQuoteGroup, SellerPickupOffer, SellerPickupShopOption } from "@/api";

// Продавец отдаёт заказ сам — из магазина, мастерской или склада (кабинет:
// «Доставка» → «Самовывоз»). Это ещё один вариант группы во вкладке «В пункт
// выдачи»; точку покупатель выбирает обязательно, цену шлюз берёт из точки.
export const SELLER_PICKUP_LABEL = "Самовывоз из магазина";

export const sellerPickupOptionOf = (offer: SellerPickupOffer): DeliveryOption => ({
	carrier: "seller_pickup",
	label: SELLER_PICKUP_LABEL,
	deliverySum: offer.minPrice,
	deliveryDays: offer.points.find((p) => p.inBuyerCity)?.readyLabel ?? offer.points[0]?.readyLabel,
	toPickupPoint: true,
	...(offer.available
		? {}
		: {
				unavailable: true,
				unavailableReason: `Самовывоз — в ${offer.cities.map((c) => `г. ${c}`).join(", ")}`,
			}),
});

// Опции квоты + самовывоз от продавца, по группе магазина.
export const withSellerPickup = (groups: DeliveryQuoteGroup[], pickup: SellerPickupShopOption[]): DeliveryQuoteGroup[] => {
	const offers = sellerPickupOfferMap(pickup);
	return groups.map((g) => {
		const offer = offers.get(g.shopId);
		return offer ? { ...g, options: [...g.options.filter((o) => o.carrier !== "seller_pickup"), sellerPickupOptionOf(offer)] } : g;
	});
};

export const sellerPickupOfferMap = (pickup: SellerPickupShopOption[]): Map<string, SellerPickupOffer> =>
	new Map(pickup.flatMap((o) => (o.offer ? [[o.shopId, o.offer] as const] : [])));
